const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class NavalTradeAgreement extends Pact {
    constructor() {
        super(
            Age.Age1,
            PactNames.NavalTradeAgreement,
            "Civilization A has +1 colonization and 1 blue token less. Civilization B has 2 extra blue tokens.",
            {}
        )
    }
}

module.exports = NavalTradeAgreement;